import React from "react";

// The Jangle wordmark (cream tiles spelling JANGLE). Transparent background,
// so it sits on both the light and dark themes. Size it with a height class.
export default function JangleLogo({ className = "h-11", ...rest }) {
  return (
    <img
      src="/brand/jangle-logo-320.webp"
      srcSet="/brand/jangle-logo-320.webp 320w, /brand/jangle-logo-640.webp 640w, /brand/jangle-logo-1100.webp 1100w"
      sizes="(min-width: 768px) 140px, 120px"
      alt="Jangle"
      draggable={false}
      className={`w-auto select-none ${className}`}
      {...rest}
    />
  );
}

// The wordmark with the "Word Raiders" tagline under it (Jack, 2026-10-12),
// sized to sit exactly beneath the A-N-G-L-E row of tiles. The tagline is an
// SVG so it scales with the logo; `logoClassName` sizes both.
export function JangleBrand({ className = "", logoClassName = "h-9", ...rest }) {
  return (
    <span className={`inline-flex flex-col leading-none ${className}`}>
      <JangleLogo className={logoClassName} {...rest} />
      <svg
        viewBox="0 0 1000 72"
        className="block w-0 min-w-full h-auto mt-[4%] text-foreground/80"
        role="img"
        aria-label="Word Raiders"
        data-testid="brand-tagline"
      >
        {/* The ANGLE row runs from about 3.5% to 99.5% of the logo's width. */}
        <text
          x="40"
          y="60"
          textLength="950"
          lengthAdjust="spacing"
          fill="currentColor"
          style={{ font: '900 60px "Outfit", system-ui, sans-serif' }}
        >
          WORD RAIDERS
        </text>
      </svg>
    </span>
  );
}
